export const RESULT_CODE = {
  SUCCESS: 'SUCCESS',
  FAIL: 'FAIL',
};



// WEBPACK FOOTER //
// ./src/const/result_code_const.js